import React from "react"
import { Card, Space, Typography, Divider } from "antd"
import { formatDateTime } from "../../utils"
import { IMovementRS } from "../../models/storageModel"

const { Text } = Typography

export interface MovementDetailGeneralInfoCardProps {
  movement: Partial<IMovementRS>
  labels: { title: string; counterparty: string; user: string }
  docType: string
  isPreparatory: boolean
  storeFrom?: string
  storeTo?: string
  suggestedStore?: string
}

const MovementDetailGeneralInfoCard: React.FC<MovementDetailGeneralInfoCardProps> = ({
  movement,
  labels,
  docType,
  isPreparatory,
  storeFrom,
  storeTo,
  suggestedStore,
}) => {
  return (
    <Card title="Información General" className="card-shadow">
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <Text type="secondary">{labels.counterparty}</Text>
          <div style={{ fontWeight: 'bold' }}>{movement.contact_name || "CONSUMIDOR FINAL"}</div>
          <div>{movement.contact_document}</div>
        </div>
        <Divider style={{ margin: '5px 0' }} />
        <div>
          <Text type="secondary">{labels.user}</Text>
          <div>{movement.created_by_user_name}</div>
        </div>
        <Divider style={{ margin: '5px 0' }} />
        <div>
          <Text type="secondary">{isPreparatory ? "Almacén sugerido / previsto:" : "Almacenes:"}</Text>
          {isPreparatory ? (
            <div>{suggestedStore || "Sin asignar"}</div>
          ) : (
            <>
              <div>{storeFrom && `Origen: ${storeFrom}`}</div>
              <div>{storeTo && `Destino: ${storeTo}`}</div>
            </>
          )}
        </div>
        <Divider style={{ margin: '5px 0' }} />
        <div>
          <Text type="secondary">
            {docType === 'PURCHASE_REQUEST' ? 'Fecha de Solicitud:'
              : docType === 'PURCHASE_ORDER' ? 'Fecha de Orden:'
              : docType === 'QUOTATION' ? 'Fecha de Cotización:'
              : 'Fecha de Factura / Documento:'}
          </Text>
          <div>{formatDateTime(movement.document_date || movement.created_at)}</div>
        </div>
        {movement.document_date && movement.created_at && (
          <div style={{ marginTop: 4 }}>
            <Text type="secondary" style={{ fontSize: 11 }}>
              {isPreparatory ? "Fecha de Creación en Sistema:" : "Fecha de Radicación (Auditoría):"}
            </Text>
            <div style={{ fontSize: 12, color: '#8c8c8c' }}>{formatDateTime(movement.created_at)}</div>
          </div>
        )}
        <Divider style={{ margin: '5px 0' }} />
        <div>
          <Text type="secondary">Detalles/Notas:</Text>
          <div>{movement.notes || "Sin notas"}</div>
        </div>
      </Space>
    </Card>
  )
}

export default MovementDetailGeneralInfoCard
